// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  stripe : {publishableKey : 'pk_test_51MRp2OD2zVFXFkpBt4OBDZU7GSw5bod3CmslOZdN98S365Q80cRfz6Qubqqvlq9OMgXBJwCmMr7MUbfcWb2eun7j008XGfyzmC'},
  apiKey : 'AIzaSyCUxnGSQN2ERavqMm_kMj1YvRFKo61isic',
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
